export default {
  custom_allergen: {
    placeholder: 'Dodaj opcję niestandardową',
  },
  buttons: {
    add: 'Dodaj',
  },
};
